import EditCheckboxContainer from './EditCheckboxContainer';

export default EditCheckboxContainer;
